import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-setex-page',
  templateUrl: './setex-page.component.html',
  styleUrls: ['./setex-page.component.scss']
})
export class SetexPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    window.scrollTo(0, 0);
  }

}
